import config from 'Cloud/config';
import { IHashCalculator } from 'Cloud/webWorkers/types';
import { transfer, wrap } from 'comlink';
import sha1 from 'js-sha1';
import { logger } from 'lib/logger';
import { sendXray } from 'reactApp/utils/ga';
import { promiseTimeout } from 'reactApp/utils/helpers';

const pathToWorker = `${config.get('BUILD_URLS').js}/calculatorWorker.js`;

export class HashCalculator {
    private ableWorker = false;
    private hashCalcWorker;
    private hash;

    static WorkerCalculatorWrapped;
    static useTransferable: boolean | null = null;

    public async init() {
        try {
            if (!HashCalculator.WorkerCalculatorWrapped) {
                await new Promise<void>((resolve, reject) => {
                    const oReq = new XMLHttpRequest();
                    oReq.addEventListener('error', function (error) {
                        logger.error('Worker load error:', error);
                        sendXray('worker-error-load');
                        reject();
                    });
                    oReq.addEventListener('load', function () {
                        try {
                            sendXray('worker-load');
                            if (!window.URL?.createObjectURL) {
                                sendXray('worker-error-blob');
                            }

                            const blob = window.URL.createObjectURL(new Blob([this.responseText]));
                            const worker = new Worker(blob);
                            worker.addEventListener('error', reject, false);

                            HashCalculator.WorkerCalculatorWrapped = wrap<{ new (): Promise<IHashCalculator> }>(worker);
                            resolve();
                        } catch (err) {
                            sendXray('worker-error-crt');
                            reject();
                        }
                    });
                    oReq.open('get', pathToWorker, true);
                    oReq.send();
                });
            }

            this.hashCalcWorker = await new HashCalculator.WorkerCalculatorWrapped();

            this.ableWorker = true;

            return this.hashCalcWorker.addData('mrCloud');
        } catch (error) {
            logger.error('Worker error:', error);
            sendXray('worker-error-exc');

            this.hash = sha1.create();

            this.hash.update('mrCloud');
        }
    }

    public async addData(dataBlock: ArrayBuffer | string): Promise<void> {
        if (!this.ableWorker && this.hash) {
            this.hash.update(dataBlock);
            return;
        }

        if (typeof dataBlock !== 'string' && dataBlock.constructor === ArrayBuffer) {
            const testArray = new ArrayBuffer(10);
            if (HashCalculator.useTransferable === null) {
                HashCalculator.useTransferable = await Promise.race([
                    this.hashCalcWorker.canUseTransferable(transfer(testArray, [testArray])),
                    promiseTimeout(2000),
                ]);
            }
            return this.hashCalcWorker.addData(HashCalculator.useTransferable ? transfer(dataBlock, [dataBlock]) : dataBlock);
        }
        return this.hashCalcWorker.addData(dataBlock);
    }

    public getHash(): Promise<string> {
        if (!this.ableWorker) {
            return Promise.resolve(this.hash?.hex().toUpperCase());
        }

        const hash = this.hashCalcWorker.getHash();
        delete this.hashCalcWorker;
        return hash;
    }
}
